import React, { useEffect, useState } from 'react'
import Button from 'components/Button/Button'
import {
  FacilitiesCourtImage,
  FacilitiesCourtImageContainer,
  FacilitiesAddress,
  FacilitiesContainer,
  FacilitiesTitle,
  FacilitiesItemContainer,
  LocationIconContainer,
  FacilitiesCourtContainer,
} from './Facilities.styled'
import { MdLocationOn } from 'react-icons/md'
import Calendar from 'components/Calendar/Calendar'
import Sidebar from 'components/SidebarContent/Sidebar'
import Portal from 'components/Portal/Portal'
import Breadcrumb from 'components/Breadcrumb'
import { Page, pages } from 'pages/pages'
import Court from 'components/Court'
import { useAppDispatch, useAppState } from 'store'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import { useParams } from 'react-router'
import moment from 'moment'
import { Location } from 'models/location'
import ReservationForm from 'pages/Reservation/ReservationForm'
import Modal from 'components/Modal'
import { SlotInfoProps } from 'pages/Reservation/ReservationForm.props'
import PageLoader from 'components/PageLoader/PageLoader'
import toast from 'cogo-toast'
import { EventCalendar } from 'types/event-calendar-types'
import { DragAndDropCalendarProps } from 'components/Calendar/Calendar.props'
import TransactionModal from 'components/TransactionModal'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'
import Spinner from 'components/Spinner'

const FACILITY_BREADCRUMB: Page[] = [pages.Home, pages.Facilities]

export default function FacilitiesPage() {
  const params: Location = useParams()
  const dispatch = useAppDispatch()
  const { appointments, courts, location, loading } = useAppState(
    state => state.appointments
  )
  const { currentTransaction } = useAppState(state => state.transaction)
  const [showSidebar, setShowSidebar] = useState<boolean>(false)
  const [slotInfo, setSlotInfo] = useState<SlotInfoProps | null>(null)
  const [currentEvent, setCurrentEvent] = useState<EventCalendar | undefined>(
    undefined
  )
  const [showReservation, setShowReservation] = useState<boolean>(false)
  const [showAppointment, setShowAppointment] = useState<boolean>(false)
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())
  const [appointmentId, setAppointmentId] = useState<number>()
  const [transactionModal, setTransactionModal] = useState<boolean>(false)
  const { logEvent } = useAmplitude()

  useEffect(() => {
    dispatch(appointmentActions.getLocation(params ? params.locationId : ''))
    logEvent(AMPLITUDE_EVENTS.APPOINTMENT_PAGE_EVENT, {
      location: params.locationId,
    })
  }, [])

  useEffect(() => {
    if (currentTransaction) {
      const { date, id } = currentTransaction.appointment
      if (date && id) {
        const parsedDate = moment(date).format('MM/DD/YYYY')
        setSelectedDate(new Date(parsedDate))
        setAppointmentId(id)
      }
    }
  }, [currentTransaction])

  useEffect(() => {
    if (!showAppointment) setAppointmentId(undefined) // reset appointment id
  }, [showAppointment])

  useEffect(() => {
    if (appointmentId && appointments && appointments.length) {
      const calendarEvent = appointments.filter(appointment => {
        if (parseInt(appointment.id) === appointmentId) return appointment
      })
      //setShowAppointment(true)
      setCurrentEvent(calendarEvent[0])
    }
  }, [appointments, appointmentId])

  useEffect(() => {
    handleGetAppointments()
  }, [selectedDate])

  const handleGetAppointments = () => {
    dispatch(
      appointmentActions.getAppointments({
        locationId: params ? params.locationId : '',
        startDate: moment(selectedDate).format('yyyy-MM-DD'),
        endDate: moment(selectedDate).format('yyyy-MM-DD'),
      })
    )
  }

  const handleSelectedEvent = async (calendarEvent: EventCalendar) => {
    setCurrentEvent(calendarEvent)
    setAppointmentId(parseInt(calendarEvent.id))
    setShowAppointment(true)
  }

  const handleResize = async (eventCalendar: DragAndDropCalendarProps) => {
    const { start, end, event } = eventCalendar
    const newStartDate = moment(start).format('YYYY-MM-DDTHH:mm:ss')
    const newEndDate = moment(end).format('YYYY-MM-DDTHH:mm:ss')
    if (params.locationId) {
      await dispatch(
        appointmentActions.updateAppointment({
          appointmentId: parseInt(event.id),
          start_date: newStartDate,
          end_date: newEndDate,
          locationId: params.locationId,
        })
      )
    }
  }

  const handleDrop = async (eventCalendar: EventCalendar) => {
    const { start, end, courts, id } = eventCalendar
    const newStartDate = moment(start).format('YYYY-MM-DDTHH:mm:ss')
    const newEndDate = moment(end).format('YYYY-MM-DDTHH:mm:ss')
    if (params.locationId) {
      if (params.locationId) {
        await dispatch(
          appointmentActions.updateAppointment({
            appointmentId: parseInt(id),
            start_date: newStartDate,
            end_date: newEndDate,
            locationId: params.locationId,
            court_ids: courts,
          })
        )
        handleGetAppointments()
      }
    }
  }

  return (
    <>
      {loading === 'loading' && !location ? (
        <PageLoader />
      ) : (
        <FacilitiesContainer>
          <Portal id={'sidebar_portal'}>
            <Sidebar
              type={'facility'}
              sidebarOpen={showSidebar}
              toggleSidebar={() => setShowSidebar(!showSidebar)}
            />
          </Portal>
          <Breadcrumb breadcrumbPages={FACILITY_BREADCRUMB} pageParam={'1'} />
          <FacilitiesItemContainer>
            <FacilitiesTitle>{location && location.name}</FacilitiesTitle>
            {/* <FacilitiesRedirect to="/">Edit Profile</FacilitiesRedirect> */}
          </FacilitiesItemContainer>

          {location && location.logo_url && (
            <FacilitiesCourtImageContainer>
              <FacilitiesCourtImage src={location.logo_url} />
            </FacilitiesCourtImageContainer>
          )}

          {location && (
            <FacilitiesItemContainer>
              <FacilitiesAddress>{location.address}</FacilitiesAddress>

              <LocationIconContainer>
                <MdLocationOn />
              </LocationIconContainer>
            </FacilitiesItemContainer>
          )}

          <FacilitiesItemContainer>
            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'Manage Schedules'}
              size={'medium'}
              style={{ marginRight: '15px' }}
            />

            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'Manage Pros'}
              size={'medium'}
              style={{ marginRight: '15px' }}
            />

            <Button
              preset={'ghost'}
              variant={'primary'}
              text={'New transaction'}
              size={'medium'}
              onClick={() => setTransactionModal(true)}
              style={{ marginRight: '15px' }}
            />
          </FacilitiesItemContainer>

          <FacilitiesCourtContainer>
            <Court
              qty={location ? location.courts.length : 0}
              title={'Regular Court Schedule'}
            />
          </FacilitiesCourtContainer>
          {loading === 'loading' && (
            <div style={{ height: 300 }}>
              <Spinner />
            </div>
          )}
          {loading !== 'loading' && courts && courts.length > 0 && (
            <>
              <Calendar
                selectable
                draggable={true}
                events={appointments ? appointments : []}
                columns={courts}
                toolbar={true}
                showDoubleTime={true}
                defaultView={'day'}
                defaultDate={selectedDate}
                onSelectedDate={setSelectedDate}
                onSelected={e => {
                  setSlotInfo(e as SlotInfoProps)
                  setShowReservation(true)
                }}
                onSelectEvent={e => handleSelectedEvent(e as EventCalendar)}
                onResize={handleResize}
                onEventDropEventCalendar={handleDrop}
              />
            </>
          )}
          {transactionModal && params && params.locationId && (
            <TransactionModal
              onClose={() => setTransactionModal(false)}
              locationId={params.locationId}
            />
          )}
          {showReservation && (
            <Modal
              showClose
              onClose={() => setShowReservation(false)}
              title="New Reservation"
              containerStyle={{ minHeight: 750 }}>
              <ReservationForm
                slotInfo={slotInfo}
                locationId={params.locationId}
                selectedDate={selectedDate}
                type="reservation"
                onClose={() => {
                  setShowReservation(false)
                }}
              />
            </Modal>
          )}
          {showAppointment && (
            <Modal
              showClose
              onClose={() => setShowAppointment(false)}
              title={'Appointment #' + appointmentId}
              containerStyle={{ minHeight: 750 }}>
              <ReservationForm
                appointmentId={appointmentId}
                slotInfo={slotInfo}
                selectedDate={selectedDate}
                currentEvent={currentEvent && currentEvent}
                locationId={params.locationId}
                type="appointment"
                onClose={(param: boolean) => {
                  setShowAppointment(false)
                  if (param) {
                    handleGetAppointments()
                    toast.success('Updated appointment', {
                      position: 'top-right',
                    })
                  }
                }}
                onDelete={() => {
                  setShowAppointment(false)
                  handleGetAppointments()
                  toast.success('Deleted appointment', {
                    position: 'top-right',
                  })
                }}
              />
            </Modal>
          )}
          {transactionModal && params && params.locationId && (
            <TransactionModal
              onClose={() => setTransactionModal(false)}
              locationId={params.locationId}
            />
          )}
        </FacilitiesContainer>
      )}
    </>
  )
}
